import React, { Component, useEffect, useState } from 'react';
import joi from 'joi';
import { Modal, Container, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from 'sweetalert';
import Select from 'react-select';
import MultiSelect from '../../Common/multiselect';
import DynamicTable from '../../Common/DynamicTable';
import validation from '../../utill/validation';
import { Row } from 'antd';
import axios from 'axios';
import api from '../../config.json'
import Table from '../../Common/table';
import dateTime from '../../utill/dateTime';
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faEye, faPlus, faFileImport, faDownload, faCopy } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Excelimport from '../../utill/Excelimport';
import Loading from '../../utill/LoadingComponent';
import { Select as AntdSelect } from 'antd'
import XLSX from 'xlsx'
import { generateExcelFile } from '../../utill/download';
import PaginationComponent from '../../Common/PaginationComponent';
import { isNumber } from 'lodash';


const CheckSheetMaster = ({ RightName, getRightsForAccess, Heading }) => {
  const sortColumn = { path: 'PartID', order: 'asc' };
  const history = useHistory();
  const [size, setSize] = useState('xl')
  const [opStatus, setopStatus] = useState('')
  const [Operation, setOperation] = useState({})
  const [componentList, setcomponentList] = useState([])
  const [modelState, setmodelState] = useState(false)
  const [Update, setUpdate] = useState({})
  const [loader, setLoader] = useState(false)
  const [templateList, setTemplateList] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] })
  const [selectedAction, setSelectedAction] = useState("")

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);

  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(5);
  const [PageSize, setPageSize] = useState(10);


  const columns = [
    { path: 'TemplateName', label: 'Template Name' },
    { path: 'check_sheet_title', label: 'Check Sheet Title' },
    { key: 'Version', label: 'No Of Checkpoint', content: (obj) => <label>{obj.checkpoints.length}</label> },
    { path: 'Version', label: 'Version' },

    // { path: 'PartName', label: 'Part Name', content: (obj) => <label>{obj.PartName ? obj.PartName : '-'}</label> },
    // { key: 'InspectionType', label: 'Inspection Type', content: (obj) => obj.Standards.map(one => <React.Fragment><label>{one.InspectionType}</label><br /></React.Fragment>) },

    // { key: 'EffectiveFrom', label: 'Effective From', content: (obj) => obj.Standards.map(one => <React.Fragment><label>{dateTime.getStringOfDateTime(one.EffectiveFrom)}</label><br /></React.Fragment>) },
    //{key:'NetWeightPerComponent',label:'Net Component Weight',content:(obj)=>obj.Operation.map(one=><React.Fragment><label>{one.NetWeightPerComponent}</label><br/></React.Fragment>)},
    // { key: 'Description', label: 'Description', content: (obj) => obj.checkpoints.map(one => <React.Fragment><label>{one.Description ? one.Description.toString() : "-"}</label><br /></React.Fragment>) },
    // { key: 'checkPointType', label: 'Checkpoint Type', content: (obj) => obj.checkpoints.map(one => <React.Fragment><label>{one.checkPointType ? one.checkPointType.toString() : "-"}</label><br /></React.Fragment>) },
    // //{key:'ScrapWeightCycle',label:'Scrap Weight / Cycle',content:(obj)=>obj.Operation.map(one=><React.Fragment><label>{one.ScrapWeightCycle?one.ScrapWeightCycle.toString():'-'}</label><br/></React.Fragment>)},
    // { key: 'Dimension', label: 'Dimension', content: (obj) => obj.checkpoints.map(one => <React.Fragment><label>{one.Dimension ? one.Dimension.toString() : "-"}</label><br /></React.Fragment>) },
    // { key: 'PlusTolerance', label: 'Plus Tolerance', content: (obj) => obj.checkpoints.map(one => <React.Fragment><label>{one.PlusTolerance ? one.PlusTolerance.toString() : "-"}</label><br /></React.Fragment>) },
    // { key: 'MinusTolerance', label: 'Minus Tolerance', content: (obj) => obj.checkpoints.map(one => <React.Fragment><label>{one.MinusTolerance ? one.MinusTolerance.toString() : "-"}</label><br /></React.Fragment>) },
    // //{key:'CyclePerParts',label:'Cycles / Part',content:(obj)=>obj.Operation.map(one=><React.Fragment><label>{one.CyclePerParts?one.CyclePerParts:'-'}</label><br/></React.Fragment>)},
    // { key: 'CTQ', label: 'CTQ', content: (obj) => obj.checkpoints.map(one => <React.Fragment><label>{one.CTQ ? "Yes" : "No"}</label><br /></React.Fragment>) },

    { key: 'createdAt', label: 'Created Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.createdAt)}</label><br /></React.Fragment> },
    { key: 'updatedAt', label: 'Last Updated Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label><br /></React.Fragment> },
    {
      key: 'update', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => {
        const template = templateList.find(x => x.Name == user.TemplateName);
        template.Columns = getColumnsWithoutUserInput(template.Columns)
        setSelectedTemplate(template)
        setUpdate(user);
        setRows(user.checkpoints);
        seterrors({})
        setopStatus('update');
      }} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faEdit} /></button>
    },
    {
      key: 'copy', content: user => <button

        disabled={
          !getRightsForAccess('StaticDataRights', RightName, "update")}
        onClick={() => {
          const template = templateList.find(x => x.Name == user.TemplateName);
          template.Columns = getColumnsWithoutUserInput(template.Columns)
          setSelectedTemplate(template)
          setUpdate(user);
          setRows(user.checkpoints);
          seterrors({})
          setopStatus('copy');
        }}
        className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faCopy} /></button>
    },
    // {
    //   key: 'Copy', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => {
    //     const template = templateList.find(x => x.Name == user.TemplateName);
    //     template.Columns = getColumnsWithoutUserInput(template.Columns)
    //     setSelectedTemplate(template)
    //     setUpdate(user);
    //     setRows(user.checkpoints);
    //     seterrors({})
    //     setopStatus('update');
    //   }} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faCopy} /></button>
    // },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }

  ]


  useEffect(() => {
    if ((opStatus == 'update') || (opStatus == 'copy')) {
      setRows(Update.checkpoints);
      setOperation({ Version: Update.Version, check_sheet_title: Update.check_sheet_title })
      setmodelState(true);
    } else {
      setRows([])
    }
  }, [opStatus])

  useEffect(() => {
    axios.get(api.api + 'uploadImage')
      .then((result) => {
        console.log(result.data, "hvhfvdhfs");
        setImageList(result.data)
      })
      .catch((err) => {
        console.log(err);
      })

    Heading('Check Sheet Master')
    getCheckpointConfig()
    getCheckSheetList()
  }, [])

  useEffect(() => {
    getCheckSheetList()
  }, [CurrentPage, PageSize])

  const getCheckpointConfig = () => {
    axios.get(api.api + 'checkPointConfig')
      .then((result) => {
        setTemplateList(result.data)
      })
      .catch((err) => {
        console.log(err);
      })
  }

  // const getCheckSheetList = () => {
  //   axios.get(api.api + 'checkSheetMaster')
  //     .then((result) => {
  //       setcomponentList(result.data)
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  // }
  const getCheckSheetList = async (search, Query) => {
    // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
    setLoader(true)

    if (search) {
      axios.put(api.api + 'checkSheetMaster', { query: 'Search', Item: Query, PageSize: PageSize, Page: CurrentPage })
        .then((result) => {
          setLoader(false)
          setTotalPage(Math.ceil(result.data.totalDocuments / PageSize));
          setcomponentList(result.data.data);
          //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
        })

        .catch((err) => {
          setLoader(false)
          console.log(err);
        })
    } else {
      axios.put(api.api + 'checkSheetMaster', { query: '', Item: '', PageSize: PageSize, Page: CurrentPage })
        .then((result) => {
          setLoader(false)
          setTotalPage(result.data.totalDocuments);
          setcomponentList(result.data.data);
          //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
        })

        .catch((err) => {
          setLoader(false)
          console.log(err);
        })
    }

  }

  const handleCloseModel = () => {
    setopStatus('');
    setmodelState(false)
  }
  const handleHideModel = () => {
    setopStatus('');
    setmodelState(false)
  }

  const handleSort = sortColumn => {
    // consol(sortColumn);
    // if (state.componentList.length > 0) {
    //   const sorted = _.orderBy(state.componentList, [sortColumn.path], [sortColumn.order]);
    //   setState({ sortColumn, componentList: sorted });
    // }
  }
  const standardSchema = {

  }
  const addRow = () => {
    // const data = rows[rows.length - 1]
    // delete data._id
    // selectedTemplate.Columns.forEach((x) => {
    //   standardSchema[x.FieldName] = joi.string().required()
    // })
    // const errors1 = validation.validate(data, standardSchema);
    // setErrors1(errors1 || {});
    //  if (errors1) return;
    if (selectedTemplate && selectedTemplate.Name) {
      setRows([...rows, { StandardType: "Description" }]);
    } else {
      swal("Please select check point template which you want to add  or import.", { dangerMode: true })
    }
  };

  const removeRow = (index) => {
    let data = [...rows];  // Create a copy of the rows array
    data.splice(index, 1);  // Remove one element at the specified index
    setRows(data);  // Update the state with the new array
  };


  // Function to handle input change in a cell
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);
  };

  const schema = {
    TemplateName: joi.string(),
    check_sheet_title: joi.string().required(),
    Version: joi.string().required(),
    checkpoints: joi.array().min(1).required(),
    _id: joi.string()
  }

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;

    setOperation((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(column => column.DbFieldName);
    headers.unshift("StandardType")
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns]
    return columns.filter(x => !x.DataType.startsWith('UserInput'))
  }


  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement('input');
    fileInputElement.type = 'file';
    fileInputElement.accept = '.xlsx, .xls';
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener('change', (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = isNumber(cell) ? cell.toString() : cell;
          });
          return obj;
        });
        const err = vaidateExcel(formattedData)

        if (err.error) {
          swal(err.message, { dangerMode: true })
          return
        }

        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };


  const vaidateExcel = (formattedData) => {
    const err = { error: false, message: "", index: 0 };
    const standardDim = selectedTemplate.Columns.find(x => x.DataType === "StandardDimension");
    const plus = selectedTemplate.Columns.find(x => x.DataType === "Dimension+Tolerance");
    const minus = selectedTemplate.Columns.find(x => x.DataType === "Dimension-Tolerance");

    const toleranceFields = [
      { field: standardDim, name: standardDim?.DbFieldName },
      { field: plus, name: plus?.DbFieldName },
      { field: minus, name: minus?.DbFieldName },
    ];

    for (let index = 0; index < formattedData.length; index++) {
      const one = formattedData[index];
      const errors = [];

      if (one.StandardType === "Description") {
        for (const { field, name } of toleranceFields) {
          if (field && one[name]) {
            errors.push(name);
          }
        }

        if (errors.length > 0) {
          err.error = true;
          err.message = `The following fields should be empty for description type  at row number ${index + 2} : \n${errors.join("\n")}`;
          err.index = index + 2;
          break; // Exit the loop if an error is found
        }
      }

      if (one.StandardType === "Dimension") {
        for (const { field, name } of toleranceFields) {
          if (field && !one[name]) {
            errors.push(name);
          }
        }

        if (errors.length > 0) {
          err.error = true;
          err.message = `The following fields should not be empty for dimension type at row number ${index + 2} : \n${errors.join("\n")}`;
          err.index = index + 2;
          break; // Exit the loop if an error is found
        }
      }
    }

    return err

  }





  const onDelete = (data) => {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        axios
          .delete(api.api + "checkSheetMaster/" + data._id, { data: data })
          .then(result => {
            getCheckSheetList()
            toast.success(`Deleted  Successfully`, {
              position: 'bottom-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: 'green', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });

          })
          .catch(err => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);

            } else {
              swal(`${err}`);

            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  }

  const validateCheckCheckPoints = (rows = []) => {

    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(x => x.DataType == "StandardDimension")
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(`Row Number ${i + 1} ${dimensionField.FieldName} is mandatory for Dimension Type check point.`)
          break;
        }
      }
    }
    return errorObj;
  };


  const handelSaveData = (data) => {
    const checksheet = { ...Operation }
    checksheet.TemplateName = selectedTemplate.Name;
    checksheet.checkpoints = data;
    delete checksheet.__v
    delete checksheet.createdAt
    delete checksheet.updatedAt
    const errors = validation.validate(checksheet, schema)
    if (errors) {
      seterrors(errors);
      return
    }
    setLoader(true)
    if (opStatus == "update") {
      axios.patch(api.api + 'checkSheetMaster/' + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getCheckSheetList();
          handleCloseModel()
          setLoader(false)
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true })
          }
          console.log(err);
          setLoader(false)
        })
    } else {
      axios.post(api.api + 'checkSheetMaster', checksheet)
        .then((result) => {
          swal("Data Saved Successfully");
          getCheckSheetList();
          handleCloseModel()
          setLoader(false)
          seterrors({})
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true })
          }
          console.log(err);
          setLoader(false)
        })
    }


  }


  const handleDownloadCheckSheet = () => {
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(column => column.DbFieldName);
    headers.unshift("StandardType")
    const worksheetData = [headers];
    rows.forEach((obj) => {
      const dataArr = []
      headers.forEach((header) => {
        dataArr.push(obj[header])
      })
      worksheetData.push(dataArr)
    })


    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Check Sheet');

    // Generate and download the Excel file
    XLSX.writeFile(workbook, Operation.check_sheet_title + "_Check-Sheet.xlsx");
    //generateExcelFile(Operation.check_sheet_title+"_Check-Sheet", new Date())
  }
  return (

    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}
      <Modal className='modal-custom' size={size} show={modelState} onHide={handleHideModel}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>{opStatus == "copy" ? "Copy " : ""}Configure Check Sheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Operation${id}`}> */}
          <Row >

            <Col sm={3}>
              <div className="form-group form-group-sm">
                <label htmlFor="operationRejectionCost">Checksheet Title</label>
                <input
                  required
                  onChange={handleOnChange}
                  style={{ width: "100%" }}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm"
                  type="text"
                  // min="0"
                  name="check_sheet_title"
                  value={Operation.check_sheet_title}
                />
                {errors.check_sheet_title && <div className="alert small alert-danger">{errors['check_sheet_title']}</div>}
              </div>
            </Col>
            <Col sm={2}>
              <div className="form-group form-group-sm">
                <label htmlFor="operationRejectionCost">Checksheet Version</label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm"
                  type="text"
                  name="Version"
                  value={Operation.Version}
                />
                {errors.Version && <div className="alert small alert-danger">{errors['Version']}</div>}
              </div>
            </Col>
            <Col sm={3}>
              <div className="form-group mt-2">
                <label htmlFor="operationRejectionCost">Select Check Point Template</label>
                <AntdSelect disabled={opStatus == 'copy'} placeholder="Check Point Template..." onChange={(value) => {
                  const template = templateList.find(x => x.Name == value);
                  setSelectedTemplate(template || {})
                  handleOnChange({ currentTarget: { name: "TemplateName", value: value } })
                }} value={selectedTemplate.Name || []} style={{ width: "100%" }}>
                  {templateList.map((one) => {
                    return <AntdSelect.Option value={one.Name}>{one.Name}</AntdSelect.Option>
                  })}
                </AntdSelect>
                {errors.TemplateName && <div className="alert small alert-danger">{errors['TemplateName']}</div>}
              </div>
            </Col>

            {selectedTemplate.Name && <Col className='mt-3' sm={2}>
              <span onClick={downloadExcel} className='btn btn-sm btn-primary mt-3'><FontAwesomeIcon icon={faDownload} /> Template</span>
            </Col>}
            {rows.length > 0 && <Col className='mt-3' sm={2}>
              <span onClick={handleDownloadCheckSheet} className='btn btn-sm btn-primary mt-3'><FontAwesomeIcon icon={faDownload} /> Check Sheet</span>
            </Col>}

            {selectedTemplate.Name && <Col className='mt-3' sm={2}>
              <button type="button" className="btn-sm btn-primary  mx-2 mt-3"
                onClick={() => handleFileUpload()}
              ><FontAwesomeIcon icon={faFileImport} /> Excel Import</button>
            </Col>}
          </Row>
          <Row >
            <Col sm={12}>
              <DynamicTable id={Operation.check_sheet_title + "_Check-Sheet"} setRows={setRows} ImageList={ImageList} handleInputChange={handleInputChange} removeRow={removeRow} addRow={addRow} errors={errors1} rows={rows} columns={getColumnsWithoutUserInput(selectedTemplate.Columns) || []} />
              {errors.checkpoints && <div className="alert small alert-danger">{errors['checkpoints']}</div>}
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()} >
            Close
          </Button>
          <Button variant="primary" onClick={() => {
            const error = validateCheckCheckPoints(rows)
            if (error.IsError) {
              swal("ERROR", error.message.join(', '), { dangerMode: true })
            } else {
              handelSaveData(rows);
            }
          }} >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {<button disabled={!getRightsForAccess('StaticDataRights', RightName, "write")} className='btn-sm btn-primary float-right' onClick={() => { setSelectedAction("add"); seterrors({}); setmodelState(true); setOperation({}); setUpdate({}); setSelectedTemplate({}); setRows([]) }}>Create Checksheet</button>}
      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Excel Import</button> */}
      {/* {getRightsForAccess('StaticDataRights', RightName, "write") && <Excelimport />} */}

      {componentList.length < 0 ? "Data Not Available" : <Table columns={columns} onSort={handleSort} sortColumn={sortColumn} data={componentList} searchquery={true} handelSearch={getCheckSheetList} />}
      {componentList.length > 0 && <div className="float-end m-3">
        <PaginationComponent
                current={CurrentPage}
                pageSize={PageSize}
                totalItems={TotalPage * PageSize}  // or just use total count
                onPageChange={(page, size) => {
                  if (size !== PageSize) setCurrentPage(1);
                  else setCurrentPage(page);
                  setPageSize(size);
                }}
              />
      </div>}
    </>

  );
}

export default CheckSheetMaster;
